import React, { useState } from 'react';
import { Card, Box, Container, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { SectionContainer, FeatureCard, CardTitle } from './Components/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ScrollAnimation from './Components/ScrollAnimation';

const FAQData = [
    {
      question: "What is Scriptu?",
      answer: "Scriptu is a comprehensive tool designed to revolutionize your LinkedIn experience. It's an AI-powered platform trusted by thousands of creators and businesses to elevate their presence on LinkedIn. With Scriptu, you can effortlessly create, schedule, and optimize engaging content tailored specifically for LinkedIn. Whether you're a content creator, freelancer, founder, or part of a team, Scriptu empowers you to grow your audience, build meaningful relationships, and unlock business opportunities on LinkedIn like never before."
    },
    {
      question: "What sets Scriptu apart from other tools?",
      answer: "Scriptu distinguishes itself with its AI-driven content creation and optimization capabilities tailored for LinkedIn. Our platform empowers users to effortlessly generate, schedule, and enhance engaging posts, leveraging various content sources like websites, videos, and documents. With advanced features such as AI-powered hooks, post readability analysis, and dynamic carousel creation, Scriptu offers unparalleled support for boosting LinkedIn engagement and building a strong online presence."
    },
    {
      question: "Who can benefit from using Scriptu?",
      answer: "Scriptu is ideal for individuals and companies seeking to establish and enhance personal brands for business purposes. Whether you're a content creator, freelancer, entrepreneur, or managing an entire team, Scriptu equips you with the tools to shine on LinkedIn and seize business opportunities."
    },
    {
      question: "How does Scriptu's free trial and refund policy work?",
      answer: "To begin your trial, simply create an account and select a plan. Once you activate your trial, you'll enjoy one week of complimentary access to Scriptu. You have the flexibility to cancel your trial at any time. If you choose to continue beyond the trial period, your first month (for monthly plans) or year (for yearly plans) will be charged. Rest assured, we offer a 30-day refund policy on your initial payment. To request a refund, simply reach out to us through the support module in the app."
    },
    {
      question: "Which subscription plan suits me best?",
      answer: "The ideal plan depends on your specific needs. - If you primarily require content management capabilities and have minimal interest in engagement or lead generation, the Starter plan may suffice. This plan allows you to schedule content and monitor performance metrics. - For users seeking assistance with content creation and efficiency in engagement, the Standard plan is recommended. This plan is our most popular option. - If you're a LinkedIn enthusiast seeking maximum functionality and access to our lead database, the Pro plan offers comprehensive features tailored to power users."
    },
    {
      question: "Can I cancel my subscription anytime? How?",
      answer: "Yes, you have the flexibility to cancel your subscription at any time. Simply navigate to the Settings section of Scriptu and access the Billing tab. From there, you can upgrade, downgrade, or cancel your subscription hassle-free."
    },
    {
      question: "Is Scriptu safe to use?",
      answer: "Scriptu provides a suite of features designed to optimize your LinkedIn experience while prioritizing safety and compliance. Unlike traditional automation tools, Scriptu focuses on empowering users to create quality content on LinkedIn and foster genuine connections. Our AI technology,  networking tools are designed to enhance your LinkedIn experience without compromising account security."
    },
    {
      question: "How does Scriptu support teams and agencies?",
      answer: "Scriptu offers robust team features, enabling organizations to leverage LinkedIn for collective growth. Teams can easily collaborate and access shared resources within the platform. For agencies offering LinkedIn-related services, Scriptu allows you to add clients to your account and streamline collaboration. With consolidated invoicing and centralized account management, Scriptu simplifies team dynamics and agency-client relationships for a seamless experience."
    }
  ];

const Faq = () => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Container maxWidth="lg" sx={{ mt: 3, mb: 15 }}>
            <SectionContainer>
                <ScrollAnimation animateIn="flipInX" delay={0.3}>
                    <Card sx={{ boxShadow: '0 0 10px 1px #4c4c4c', borderRadius: '20px', padding: '30px' }}>
                        <Typography variant="h3" sx={{ fontSize: '44px', color: '#000135', fontWeight: 700, lineHeight: 1.13, letterSpacing: '-1.76px', mt: 5, mb: 2 }}>
                            Frequently Asked Questions
                        </Typography>


                        <Typography variant="body1" sx={{ mt: 2, mb: 7 }}>
                            More questions? Email us at contact@scriptu.io
                        </Typography>

                        <Box sx={{ mb: 8 }}>
                            {FAQData.map((faq, index) => (
                                <Accordion 
                                key={index} expanded={expanded === `panel${index}`} 
                                onChange={handleChange(`panel${index}`)}
                                sx={{ boxShadow: '0 0 10px 1px #4c4c4c', borderRadius: '10px', mb: 2 }}
                                 >
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel${index}bh-content`} id={`panel${index}bh-header`}>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                            {faq.question}
                                            </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography variant="body1" sx={{ fontWeight: 400, textAlign: 'left' }}>
                                            {faq.answer}
                                            </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </Box>



                    </Card>
                </ScrollAnimation>
            </SectionContainer>
        </Container>
    );
};

export default Faq;
